import script from "./SupportDeskIcon.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./SupportDeskIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportDeskIcon.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./SupportDeskIcon.vue?vue&type=script&setup=true&lang=ts"

import "./SupportDeskIcon.vue.css?vue&type=style&index=0&id=b60d65c1&lang=css!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./SupportDeskIcon.vue?vue&type=style&index=0&id=b60d65c1&lang=css"

const __exports__ = script;

export default __exports__